import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import qs from 'qs';
import { Loader, Title } from '@/components';
import { BreadCrumbs, Container, SpecialOffers } from '@/containers';
import { getCorrectName } from '@/utils';
import mindbox from '@/seo/Mindbox';
import getLinkProps from '@/lib/getLinkProps';

import styles from './SpecialOffersPage.module.scss';

const Pagination = dynamic(() => import('../../components/pagination'), {
	loading: () => <Loader />,
});

const SpecialOffersPage = ({ articles, meta, seo }) => {
	const router = useRouter();
	const { query } = router;
	const { total, per_page, last_page } = meta || {};
	const { page = 1 } = qs.parse(query);
	const [specialOffersHref, _specialOffersAs, specialOffersTitle] = getLinkProps({
		type: 'special-offers',
	});
	const breadCrumbsSpecialOffers = [{ slug: specialOffersHref, name: specialOffersTitle }];

	useEffect(() => {
		mindbox.viewPage({ page: 'SpecialOffers' });
	}, []);

	return (
		<section className={styles.offersSection}>
			<Container>
				<div className={styles.breadCrumbs}>
					<BreadCrumbs type='news' breadcrumbs={breadCrumbsSpecialOffers} />
				</div>
				<Title component='h1' mb='large'>
					{seo && seo.h1 ? getCorrectName(seo.h1) : 'Акции'}
				</Title>

				<SpecialOffers items={articles} />

				{total > per_page && <Pagination lastPage={last_page} currentPage={page} shallow={false} />}
			</Container>
		</section>
	);
};

export default SpecialOffersPage;
